export default {
	palette: {
		primary: {
			main: '#009688',
		},
	},
};
